import { css as universeCss } from '../../../components/universe';
import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage13(tl: GSAPTimeline, refs: AnimationRefs, _viewport: Viewport) {
  const moveToButton = () => ({
    x: () => {
      const star = refs.stars[0].current?.getBoundingClientRect();
      const btn = refs.buttons.confirm.current?.getBoundingClientRect();
      const starInitialPosX = refs.stars[0].current ? parseFloat(getComputedStyle(refs.stars[0].current).left) : 0;
      let to = 0;

      if (star && btn) {
        to = btn.left + btn.width / 2 - (starInitialPosX + star.width / 2);
      }

      return to;
    },
    y: () => {
      const star = refs.stars[0].current?.getBoundingClientRect();
      const btn = refs.buttons.confirm.current?.getBoundingClientRect();
      const starInitialPosY = refs.stars[0].current ? parseFloat(getComputedStyle(refs.stars[0].current).top) : 0;
      let to = 0;

      if (star && btn) {
        to = btn.top + btn.height / 2 - (starInitialPosY + star.height / 2);
      }

      return to;
    },
  });

  tl.to(
    refs.buttons.action.current,
    {
      scale: 1,
      x: -30,
      duration: 2,
    },
    'stage13'
  )
    .to(
      refs.buttons.confirm.current,
      {
        alpha: 1,
        duration: 2,
      },
      'stage13'
    )
    .to(
      refs.buttons.decor.current,
      {
        scale: 1,
        x: 25,
        duration: 2,
      },
      'stage13'
    );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage13',
    animations: [
      {
        ...moveToButton(),
        scale: 1,
        duration: 2,
      },
      {
        ...moveToButton(),
        scale: 1,
        duration: 2,
      },
      {
        ...moveToButton(),
        scale: 1,
        duration: 2,
      },
      {
        ...moveToButton(),
        scale: 1,
        duration: 2,
      },
      {
        ...moveToButton(),
        scale: 1,
        duration: 2,
      },
      undefined,
      {
        ...moveToButton(),
        scale: 1,
        duration: 2,
        onComplete: () => {
          refs.stars[4].current?.classList.remove(`${universeCss.shadow}`);
          refs.stars[6].current?.classList.remove(`${universeCss.shadow}`);
        },
      },
    ],
  });
}
